import {
  GET_SETTING_PENDING,
  GET_SETTING_FULFILLED,
  GET_SETTING_REJECTED
} from "../actions/setting";

const initialState = {
  fetching: false,
  setting: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SETTING_PENDING:
      return {
        ...state,
        fetching: true
      };
    case GET_SETTING_FULFILLED:
      return {
        ...state,
        setting: action.payload,
        fetching: false
      };
    case GET_SETTING_REJECTED:
      return {
        ...state,
        fetching: false
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/settingReducer.js